import { ReactNode } from "react";

interface TableProps<T> {
  headers: string[];
  data: T[];
  renderRow: (item: T) => ReactNode;
  keyExtractor: (item: T) => string | number;
}

const Table = <T extends { id: string | number }>({
  headers,
  data,
  renderRow,
  keyExtractor,
}: TableProps<T>) => {
  return (
    <table className="table-fixed w-full text-left rtl:text-right my-4 text-sm">
      <thead className="bg-gray-50">
        <tr>
          {headers.map((header, index) => (
            <th key={index} className="border px-2 py-2 font-medium text-left break-words">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr key={keyExtractor(item)}>{renderRow(item)}</tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
